{
  "version": 1,
  "asset_id": "c7e563fb-f44b-439b-80e5-3cdc992e1804",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/c7e563fb-f44b-439b-80e5-3cdc992e1804/sleeve-fitzer-1-220.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/c7e563fb-f44b-439b-80e5-3cdc992e1804/sleeve-fitzer-1-220.webp",
  "original_filename": "sleeve-fitzer-1-220.webp",
  "size": 3970,
  "content_type": "image/webp",
  "created_at": "2026-09-29T01:15:23Z"
}
